import { isSandboxCapacityPark } from "@repo/realtime/events/is-sandbox-capacity-park";

import { isFollowStopStatus } from "@/lib/session/is-follow-stop-status";

// A capacity park is waiting_human but resumes on its own, so following goes on.
export function isFollowStopSession(session: {
  status: string;
  statusReason?: string | null;
}): boolean {
  return isFollowStopStatus(session.status) && !isSandboxCapacityPark(session);
}
